class Tarifa {
  constructor() {
    this.id = null;
    this.idCliente = null;
    this.idServicoItem = null;
    this.nome = null;
    this.valorPercentual = 0;
    this.dataVigenciaInicial = null;
    this.dataVigenciaFinal = null;
  }
}
export default Tarifa;